import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import "../Resigter/resigterPage.css";
import axios from "axios";
import Swal from "sweetalert2";
import imagephone from "../../images/High res mobile.png";
import { Modal } from "react-bootstrap"; // already imported in your code

function RegisterPage() {
  const [fullName, setFullName] = useState(""); // State for full name
  const [email, setEmail] = useState(""); // State for email
  const [password, setPassword] = useState(""); // State for password
  const [phone, setPhone] = useState(""); // State for password
  const [dob, setDob] = useState(""); // State for password
  const navigate = useNavigate(); // Initialize useNavigate
  const [passwordError, setPasswordError] = useState("");
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [termsModalVisible, setTermsModalVisible] = useState(false);
  const [termsContent, setTermsContent] = useState("");
  const [femail, setFEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubscribe = async () => {
    if (!email) {
      setMessage("Please enter a valid email.");
      return;
    }

    try {
      const response = await fetch(
        "https://api.convertkit.com/v3/forms/7878458/subscribe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            api_key: "3bkwOyREXJsvpFPZ5iUAAw",
            email: femail,
          }),
        }
      );

      const data = await response.json();
      if (data.subscription) {
        setMessage(
          "Success! Please check your email to confirm your subscription."
        );
        setFEmail(""); // Clear input
      } else {
        setMessage(data.message || "Something went wrong.");
      }
    } catch (error) {
      setMessage("Subscription failed. Please try again later.");
      console.error(error);
    }
  };

  const showAutoCloseAlert = (message) => {
    Swal.fire({
      position: "top-end",
      icon: "success",
      title: message,
      showConfirmButton: false,
      timer: 1500,
    });
  };

  const showAutoError = (message) => {
    Swal.fire({
      position: "top-end",
      icon: "error",
      title: message,
      showConfirmButton: false,
      timer: 3000,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Email validation regex
    const phoneRegex = /^[0-9]{9,14}$/; // Basic 10-digit phone number

    if (!emailRegex.test(email)) {
      showAutoError("Please enter a valid email address.");
      return;
    }

    if (!phoneRegex.test(phone)) {
      showAutoError(
        "Please enter a valid phone number with numbers only and no spaces (9-14 digits)."
      );
      return;
    }

    if (!dob) {
      showAutoError("Please enter your date of birth.");
      return;
    }

    const dobDate = new Date(dob);
    if (isNaN(dobDate.getTime())) {
      showAutoError("Please enter a valid date of birth.");
      return;
    }

    // ✅ Age verification: check if user is at least 18
    const today = new Date();
    let age = today.getFullYear() - dobDate.getFullYear();
    const m = today.getMonth() - dobDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dobDate.getDate())) {
      age--;
    }

    if (age < 18) {
      showAutoError("You must be at least 18 years old to register.");
      return;
    }

    if (password.length === 0) {
      setPasswordError("Password cannot be empty.");
      return;
    }

    if (password.length > 12) {
      setPasswordError("Password should not exceed 12 characters.");
      return;
    }

    if (!acceptedTerms) {
      showAutoError("Please accept the Terms & Conditions to proceed.");
      return;
    }
    setPasswordError(""); // Clear error message if validation passes

    try {
      const response = await axios.post(
        "https://toptennis.io/api/user/register",
        {
          name: fullName,
          email,
          password,
          phone,
          dob,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 201 || response.data.status) {
        const { _id, name, email, profile_image, credits } =
          response.data.userData;

        // Store user data in localStorage
        localStorage.setItem("fullName", name);
        localStorage.setItem("email", email);
        localStorage.setItem("profile_image", profile_image);
        localStorage.setItem("userId", _id);

        showAutoCloseAlert("Registration successful.");
        navigate("/");
      } else {
        showAutoError("Please enter a valid email address.");
      }
    } catch (error) {
      showAutoError(
        "This email is already registered. Please login.",
        error.response?.data?.message || error.message
      );
    }
  };

  const handleLogin = () => {
    navigate("/");
  };

  const handleTermsClick = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.get(
        "https://toptennis.io/api/admin/Termstext"
      );
      const terms = response.data;
      if (terms.length > 0) {
        setTermsContent(terms[0].content); // Assuming you're storing one terms doc
      } else {
        setTermsContent("No Terms & Conditions available.");
      }
      setTermsModalVisible(true);
    } catch (error) {
      console.error("Error fetching Terms:", error);
      setTermsContent("Failed to load Terms & Conditions.");
      setTermsModalVisible(true);
    }
  };

  return (
    <>
      <div className="page-container">
        {/* Hero Section */}
        <div className="hero-section">
          {/* Phone Image */}
          <div className="hero-image">
            <img src={imagephone} alt="App Preview" className="imgphone1" />
          </div>

          {/* Text Content */}
          <div className="hero-text">
            <p className="head1">Top Tennis UK</p>
            <p className="head2">
              Start Playing For <span className="free">Free</span> Today!
            </p>
            <p className="head5">a new way to play fantasy sports</p>
          </div>

          {/* Login Box */}
          <div className="login-box">
            <h5 className="modal-title">Register</h5>
            <form onSubmit={handleSubmit}>
              <div className="input-container1">
                <input
                  type="text"
                  required
                  placeholder="Enter Full Name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)} // Update state on input change
                />
                <label>Full Name</label>
              </div>
              <div className="input-container1">
                <input
                  type="text"
                  required
                  placeholder="Enter Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)} // Update state on input change
                />
                <label>Email Address</label>
              </div>
              <div className="input-container1">
                <input
                  type="password"
                  required
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)} // Update state on input change
                  maxLength={12} // Limits input to 12 characters
                />
                <label>Password</label>
                {passwordError && (
                  <span
                    style={{
                      color: "red",
                      fontSize: "12px",
                      paddingLeft: "4%",
                    }}
                  >
                    {passwordError}
                  </span>
                )}
              </div>
              <div className="input-container1">
                <input
                  type="tel"
                  inputmode="numeric"
                  // pattern="[0-9]*"
                  maxlength="14"
                  placeholder="Enter Phone Number"
                  oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)} // Update state on input change
                  required
                />
                <label>Phone Number</label>
              </div>
              <div className="input-container1">
                <input
                  type="Date"
                  required
                  value={dob}
                  onChange={(e) => setDob(e.target.value)} // Update state on input change
                />
                <label>Date Of Birth</label>
              </div>
              <div
                className="terms-container"
                style={{ marginTop: "15px", color: "white" }}
              >
                <input
                  type="checkbox"
                  id="terms"
                  checked={acceptedTerms}
                  onChange={(e) => setAcceptedTerms(e.target.checked)}
                  style={{ marginRight: "8px" }}
                />
                <label htmlFor="terms">
                  I agree to the{" "}
                  <a
                    href="https://toptennis.io/terms"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "lightblue",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    Terms & Conditions
                  </a>{" "}
                  And{" "}
                  <a
                    href="https://toptennis.io/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "lightblue",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    Privacy Policy
                  </a>
                </label>
              </div>

              <button type="submit" className="btn" disabled={!acceptedTerms}>
                Continue
              </button>
            </form>
            <div
              className="register-link"
              style={{ marginTop: "10px", textAlign: "center" }}
            >
              <span style={{ color: "white" }}>Already have an account? </span>
              <button
                onClick={handleLogin}
                style={{
                  background: "none",
                  color: "lightblue",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Login
              </button>
            </div>
          </div>
        </div>

        {/* Footer Section */}
        <div>
          <div className="card-footernew">
            <div className="footer">
              <div className="footer-firstline">
                <div className="footer-sub">
                  <h4>Keep in touch</h4>
                  <h5>Join our newsletter. We promise not to spam!</h5>
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="footer-input"
                    value={femail}
                    onChange={(e) => setFEmail(e.target.value)}
                  />
                  <button className="subscribe-btn" onClick={handleSubscribe}>
                    Subscribe
                  </button>
                  {message && (
                    <p style={{ marginTop: "10px", marginLeft: "5px" }}>
                      {message}
                    </p>
                  )}
                </div>

                <div className="footer-sub1">
                  <h4>Quick links</h4>
                  <a href="/news" className="footer-link">
                    News
                  </a>
                  <a href="/faq" className="footer-link">
                    FAQs
                  </a>
                </div>

                <div className="footer-sub1 secondicon">
                  <h4>Socials</h4>
                  <div className="social-icons">
                    <a
                      href="https://www.facebook.com/toptennisio/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-circle"
                      style={{ textDecoration: "none" }}
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a
                      href="https://www.instagram.com/toptennisuk"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-circle"
                      style={{ textDecoration: "none" }}
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  </div>
                  <div className="fl1">
                  <a
                    href="/terms"
                    className="footer-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    T&Cs
                  </a>
                  <a
                    href="/privacy"
                    className="footer-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                    <span className="footer-link">
                      Email: contact@toptennis.io
                    </span>
                </div>
                </div>

                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RegisterPage;
